import React, {Component} from "react";
import Button from 'react-bootstrap/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {Server, ConfirmModal, helper} from "../app";

export default class ProjectManagement extends Component 
{
    //static contextType = Router-History;      

    constructor (props)
    {
        super(props);

        this.state = {confirm_message: '', on_confirm: () => {}};

        this.newProject = this.newProject.bind(this);
        this.getSpecification = this.getSpecification.bind(this);
        this.getPricelist = this.getPricelist.bind(this);
    }

    newProject ()
    {
        this.setState({
            confirm_message: 'Создание нового проекта очистит всю информацию по текущему',
            on_confirm: () => 
            {
                this.props.on_new_project();
                this.setState({confirm_message: ''});
            }
        });
    }
    getSpecification ()
    {
        //console.log(this.props.project);
        Server.instance.load('specification', {project: this.props.project});
    }
    getPricelist ()
    {
        //console.log(this.props.products);
        Server.instance.load('pricelist', {products: this.props.products});
    }

    render () 
    {
        const haveFragments = !helper.isNotObjectOrEmpty(this.props.fragments),
            fragmentsList = haveFragments ? Object.keys(this.props.fragments).map(fragmentID => 
            {
                const fragment = this.props.fragments[fragmentID];
                return <div key={`pm_fragment${fragmentID}`} className="mb-2">
                    <Button onClick={e => this.props.on_select_fragment(fragmentID)} as="span" variant="outline-secondary" className={'btn-outline-secondary_dashed btn-sm'}>{fragment.name}</Button>
                    <button onClick={e => this.props.on_delete_fragment(fragmentID)} type="button" className="close float-none ml-2" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            }) : [];

        return (<>                
            <div className="mb-3">
                <Button onClick={this.getSpecification} variant="outline-primary" className="mr-2 mb-1">Спецификация в Excel</Button>
                <Button onClick={this.getPricelist} variant="outline-secondary mb-1">Бюджетная оценка</Button>
            </div>
            <div className="mb-4">
                <h5 className="mb-3">Проект</h5>
                <Button onClick={this.newProject} as="a" variant="secondary">
                    <FontAwesomeIcon icon={faPlus} />
                    НОВЫЙ ПРОЕКТ
                </Button>
            </div>
            <div className="mb-3">
                <h5 className="mb-3">Фрагмент</h5>
                <Button onClick={this.props.on_new_fragment} as="a" variant="secondary">
                    <FontAwesomeIcon icon={faPlus} />
                    НОВЫЙ ФРАГМЕНТ
                </Button>
            </div>
            <div>
                <h6 className="mb-3">Редактировать</h6>
                <div>
                    {fragmentsList}
                </div>
            </div>
            <ConfirmModal 
                on_close={() => this.setState({confirm_message: ''})} 
                on_ok={this.state.on_confirm} 
                on_cancel={() => this.setState({confirm_message: ''})} 
                message={this.state.confirm_message} />
        </>);
    }
}
//withRouter(ProjectManagement);
/*
<div key={`pi_fragment${fragmentID}`} className="pt-1">
            <Button onClick={e => this.props.on_select_fragment(fragmentID)} as="a" variant="outline-secondary" className="btn-outline-secondary_dashed active ml-5" size="sm">{fragment.name}</Button>                        
        </div>

const FragmentsEdit = (props) => 
{
    const location = useLocation(),
        fragmentsButtons = props.fragments.map(fragment => 
        {
            const fragmentRegExp = new RegExp(''); // @todo в общем регулярка должна понимать есть ли в начале url текущегофрагмента

            // /\/fragment1/

            return <div className="mb-2">
                <Link to={fragment.url}><Button as="span" variant="outline-secondary" className={'btn-outline-secondary_dashed btn-sm '+location.pathname.search() >= 0 ? ' active' : ''}>{fragment.name}</Button></Link>
                <button onClick={this.props.delFragment} type="button" className="close float-none ml-2" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        });

    return <>{fragmentsButtons}</>;
}
*/